import React from "react";
import { Button } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../../../../../Contexts/user";

const ContractHeader = () => {
  const navigate = useNavigate();
  const { logout } = useUserContext();

  const handleLogout = () => {
    logout();

    navigate("/login");
  };

  return (
    <div className="contract-header">
      <div className="header-inner">
        <div className="header-brand">
          <div className="header-logo" onClick={() => navigate('/welcome')} style={{ cursor: 'pointer' }}>A</div>
          <div className="header-show-info">
            <h1>Arett Sales Open House 2026</h1>
            <div className="show-dates">
              <span>Virtual: Saturday, 08/01/2026 - Thursday, 12/01/2026</span>
              {" • "}
              <span>Live: Wednesday, 09/16/2026 - Thursday, 09/17/2026</span>
            </div>
          </div>
        </div>
        <a href="mailto:itsupport@arett.com" className="header-support-link">
          itsupport@arett.com
        </a>
        <Button
          type="primary"
          icon={<LogoutOutlined />}
          onClick={handleLogout}
          danger
        >
          Logout
        </Button>
      </div>
    </div>
  );
};

export default ContractHeader;
